import React, { useCallback } from "react";
import { LocalParticipant as TwilioParticipant } from "twilio-video";
import { useLocalTracks } from "./useLocalTracks";
import { Icon } from "components/shared/icon/Icon";
import styles from "./LocalParticipant.module.css";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "store/store";
import { toggleShowOnlyLocalVideo } from "store/local-tracks/slice";
import { isMobile } from "react-device-detect";
import { RootState } from "store/reducers";

interface ParticipantProps {
  participant: TwilioParticipant;
  inSidebar?: boolean;
}

export const LocalParticipant: React.FC<ParticipantProps> = ({
  participant,
  inSidebar,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { busy } = useSelector((s: RootState) => s.localTracks);
  const {
    videoRef,
    audioRef,
    muteAudio,
    videoTrackInfo,
    showOnlyLocalVideo,
  } = useLocalTracks(participant);

  const onClick = useCallback(() => {
    if (busy.video) {
      return;
    }

    if (showOnlyLocalVideo) {
      if (!isMobile) {
        dispatch(toggleShowOnlyLocalVideo());
      }
    } else {
      dispatch(toggleShowOnlyLocalVideo());
    }
  }, [dispatch, busy, showOnlyLocalVideo]);

  return (
    <>
      {isMobile && showOnlyLocalVideo && (
        <div className={styles["exit-preview"]}>
          <button
            className="btn btn-primary"
            type="button"
            onClick={() => dispatch(toggleShowOnlyLocalVideo())}
            disabled={busy.video}
          >
            Exit Camera Preview
          </button>
        </div>
      )}
      <div
        className={`${styles["participant"]} ${
          inSidebar ? styles["sidebar"] : styles["absolute"]
        }
        } ${showOnlyLocalVideo ? styles["full"] : ""}`}
        onClick={onClick}
      >
        {muteAudio && (
          <Icon className={styles["muted-participant"]} id="microphone"></Icon>
        )}
        <div
          className={`${styles["video-element"]} ${
            isMobile ? styles["video-element-portrait"] : ""
          } ${
            /back/.test(videoTrackInfo?.label.toLowerCase() || "")
              ? ""
              : styles["mirror"]
          } ${showOnlyLocalVideo ? styles["full"] : ""}`}
        >
          <video ref={videoRef} autoPlay={true} />
          <audio ref={audioRef} autoPlay={true} muted={true} />
        </div>
      </div>
    </>
  );
};
